/* eslint-disable react-hooks/exhaustive-deps */
import { Diversity1, ManageAccounts } from "@mui/icons-material";
import { Box, Card, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { v4 } from "uuid";
import Loader from "../../components/Loader/Loader";
import { ROLE } from "../../enums/rolesEnum";
import { capitalise, getUserData } from "../../utils/FunctionHelpers";
import { withSnackbar } from "../../utils/SnackbarHOC";
import { theme } from "../../utils/Theme";
import { getAll } from "../Services/MissionService";
import {
  getPilotageClients,
  getPilotageClientsDetail,
  getPilotageConsultants,
  getPilotageConsultantsDetail,
} from "../Services/PilotageService";
import { getAllImportationSource } from "../Services/SourceService";
import { getConsultantsAndManagers } from "../Services/UserService";
import { default as BarChartt, default as KPIChart } from "./Components/BarChart";
import ComparativeTable from "./Components/ComparativeTable";
import FilterPilote from "./Components/FilterPilote";
import MonthlyEvolutionCharts from "./Components/MonthlyEvolutionCharts";
import ProductionDetailModal from "./Components/ProductionDetailModal";
import Sourcing from "./Components/Sourcing/Sourcing";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

const Pilot = ({ snackbarShowMessage }) => {
  const [indexTab, setIndexTab] = useState(0);
  const [managers, setManagers] = useState([]);
  const [loading, setLoading] = useState(true);
  const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));
  const { filters } = useSelector((state) => state.filtersKPIConsultants);
  const [sourcesIds, setSourcesIds] = useState([]);
  const currentUserRole = getUserData()?.role;

  const filtersMissions = useSelector(
    (state) => state.filtersKPIMissions.filters
  );
  const initialChartsData = {
    prod: {
      id: "prod",
      list: [
        `Sourcé (${0})`,
        `Envoi(${0})`,
        `Révélation (${0})`,
        `Propales (${0})`,
        `Signatures (${0})`,

      ],
      values: [0, 0, 0, 0, 0],
    },
    kpi: {
      id: "kpi",
      list: [
        `TSO (Envois/Sourcé): ${0}%`,
        `TR (Envois/préqualif): ${0}%`,
        `TP (Propales/Préqualif): ${0}%`,
        `TS (Sign/Préqualif): ${0}%`,
      ],
      values: [0, 0, 0],
    },
  };

  const METRIC_TYPES = ["Sourcing", "Envoi", "Révélation", "Propale", "Signature"];

  const [detailModal, setDetailModal] = useState({
    open: false,
    metricType: null,
    data: [],
    loading: false,
    error: null,
  });
  const [metricCounts, setMetricCounts] = useState({});
  const detailRequestId = useRef(0);

  const [chartsData, setChartsData] = useState(initialChartsData);
  const initialMonths = Array(12)
    .fill(0)
    .map((_, index) => capitalise(moment().month(index).format("MMM")));

  const initialEvolutionData = initialMonths.map((month) => ({
    Sourcing: 0,
    Envois: 0,
    Révélations: 0,
    Propales: 0,
    Signatures: 0,
    month,
  }));


  const [evolutionData, setEvolutionData] = useState(initialEvolutionData);
  const [compareData, setCompareData] = useState([]);
  const [missionData, setMissionData] = useState([]);
  const location = useLocation();

  const resetData = () => {
    setChartsData(initialChartsData);
    setEvolutionData(initialEvolutionData);
    setCompareData([]);
  };

  const resetParamsUrl = () => {
    const params = new URLSearchParams();
    params.append("statut", "910f357b-0b13-4f66-89a8-5c06964c1dcf");
    return params;
  };

  const getInitialParameters = () => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.toString()) return searchParams;
    return resetParamsUrl();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data } = await getAll(getInitialParameters());
        setMissionData(data.missions);
      } catch (error) {
        snackbarShowMessage(error.message, "error", 4000);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const queryParams = new URLSearchParams();
      try {
        queryParams.append("role", ROLE.ROLE_CONSULTANT);
        queryParams.append("isActive", true);
        setManagers([]);
        const search = `?${queryParams.toString()}`;
        const { data } = await getConsultantsAndManagers(search);
        setManagers(data.managers);
        managers.filter((consultant) => consultant.uuid)
          .map((consultant) => consultant.uuid);
      } catch (error) {
        snackbarShowMessage(
          "Erreur de chargement des consultants et managers.",
          "error",
          4000
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [indexTab]);

  useEffect(() => {
    const fetchData = () => {
      resetData();
      if (indexTab === 0) {
        loadPilotageConsultant(
          filters.selectedConsultants,
          filters.startDate,
          filters.endDate
        );
      } else if (indexTab === 1) {
        loadPilotageClients(
          filtersMissions.selectedMissions,
          filtersMissions.startDate || filters.startDate,
          filtersMissions.endDate || filters.endDate
        );
      } else if (indexTab === 2) {
        handleSourcing(
          filtersMissions.startDate || filters.startDate,
          filtersMissions.endDate || filters.endDate
        );
      } else {
        resetData();
      }
    };
    fetchData();
  }, [filters, filtersMissions, indexTab]);

  const loadData = (queryParams, requestService) => {
    setLoading(true);
    requestService(queryParams)
      .then(({ data }) => {
        const { Production, KPI, Evolution, Comparatif } = data;
        let localEvolutionData = [];
        setChartsData({
          prod: {
            id: "prod",
            list: [
              `Sourcé (${Production["Sourcing"]})`,
              `Envois  (${Production["Envoi"]})`,
              `Révélations  (${Production["Révélation"]})`,
              `Propales (${Production["Propale"]})`,
              `Signatures (${Production["Embauche/Integration"]})`,
            ],
            values: [
              Production["Sourcing"],
              Production["Envoi"],
              Production["Révélation"],
              Production["Propale"],
              Production["Embauche/Integration"],
            ],
          },
          kpi: {
            id: "kpi",
            list: [
              `TSO (Envois/Sourcé): ${KPI["TSO"]}%`,
              `TR (Rév°/Envois): ${KPI["TR"]}%`,
              `TP (Propales/Envois): ${KPI["TP"]}%`,
              `TS (Sign/Envois): ${KPI["TS"]}%`,
            ],
            values: [KPI["TSO"], KPI["TR"], KPI["TP"], KPI["TS"]],
          },
        });
        setMetricCounts({
          Sourcing: Production["Sourcing"],
          Envoi: Production["Envoi"],
          Révélation: Production["Révélation"],
          Propale: Production["Propale"],
          Signature: Production["Embauche/Integration"],
        });
        Object.keys(Evolution).forEach((month) => {
          localEvolutionData.push({
            Sourcing: Evolution[month]["Sourcing"],
            Envois: Evolution[month]["Envoi"],
            Révélations: Evolution[month]["Révélation"],
            Propales: Evolution[month]["Propale"],
            Signatures: Evolution[month]["Embauche/Integration"],
            month,
          });
        });
        setEvolutionData(localEvolutionData);
        setCompareData(Comparatif);
      })
      .catch((error) => {
        snackbarShowMessage("Erreur de chargement de données.", "error", 4000);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const loadPilotageConsultant = (consultants, startDate, endDate) => {
    const queryParams = `?consultants[]=${consultants.join(
      "&consultants[]="
    )}&startDate=${moment(startDate).format("YYYY-MM-DD")}&endDate=${moment(
      endDate
    ).format("YYYY-MM-DD")}`;
    loadData(queryParams, getPilotageConsultants);
  };

  const handleProductionBarClick = (barIndex) => {
    const metricType = METRIC_TYPES[barIndex];
    if (!metricType) return;

    const requestId = ++detailRequestId.current;
    setDetailModal({ open: true, metricType, data: [], loading: true, error: null });

    let queryParams;
    let detailService;

    if (indexTab === 0) {
      queryParams =
        `?consultants[]=${filters.selectedConsultants.join("&consultants[]=")}` +
        `&startDate=${moment(filters.startDate).format("YYYY-MM-DD")}` +
        `&endDate=${moment(filters.endDate).format("YYYY-MM-DD")}` +
        `&type=${encodeURIComponent(metricType)}`;
      detailService = getPilotageConsultantsDetail;
    } else if (indexTab === 1) {
      queryParams =
        `?missions[]=${filtersMissions.selectedMissions.join("&missions[]=")}` +
        `&startDate=${moment(filtersMissions.startDate || filters.startDate).format("YYYY-MM-DD")}` +
        `&endDate=${moment(filtersMissions.endDate || filters.endDate).format("YYYY-MM-DD")}` +
        `&type=${encodeURIComponent(metricType)}`;
      detailService = getPilotageClientsDetail;
    } else {
      setDetailModal((prev) => ({ ...prev, loading: false, error: "Onglet non supporté." }));
      return;
    }

    detailService(queryParams)
      .then(({ data }) => {
        if (requestId !== detailRequestId.current) return;
        setDetailModal((prev) => ({
          ...prev,
          loading: false,
          data: Array.isArray(data) ? data : (data.items ?? []),
        }));
      })
      .catch(() => {
        if (requestId !== detailRequestId.current) return;
        setDetailModal((prev) => ({
          ...prev,
          loading: false,
          error: "Erreur de chargement des données.",
        }));
      });
  };

  const handleEvolutionBarClick = (metricType, monthKey) => {
      const refMonth = moment(monthKey, "MMM YYYY", "en");
      if (!refMonth.isValid()) return;

      const endDate = refMonth.clone().date(19);
      const startDate = refMonth.clone().subtract(1, "month").date(20);

      const requestId = ++detailRequestId.current;
      setDetailModal({ open: true, metricType, data: [], loading: true, error: null });

      let queryParams;
      let detailService;

      if (indexTab === 0) {
        queryParams =
            `?consultants[]=${filters.selectedConsultants.join("&consultants[]=")}` +
            `&startDate=${startDate.format("YYYY-MM-DD")}` +
            `&endDate=${endDate.format("YYYY-MM-DD")}` +
            `&type=${encodeURIComponent(metricType)}`;
        detailService = getPilotageConsultantsDetail;
      } else if (indexTab === 1) {
        queryParams =
            `?missions[]=${filtersMissions.selectedMissions.join("&missions[]=")}` +
            `&startDate=${startDate.format("YYYY-MM-DD")}` +
            `&endDate=${endDate.format("YYYY-MM-DD")}` +
            `&type=${encodeURIComponent(metricType)}`;
        detailService = getPilotageClientsDetail;
      } else {
        setDetailModal((prev) => ({ ...prev, loading: false, error: "Onglet non supporté." }));
        return;
      }

      detailService(queryParams)
          .then(({ data }) => {
            if (requestId !== detailRequestId.current) return;
            setDetailModal((prev) => ({
              ...prev,
              loading: false,
              data: Array.isArray(data) ? data : (data.items ?? []),
            }));
          })
          .catch(() => {
            if (requestId !== detailRequestId.current) return;
            setDetailModal((prev) => ({
              ...prev,
              loading: false,
              error: "Erreur de chargement des données.",
            }));
          });
    };
  const loadPilotageClients = (missions, startDate, endDate) => {
    const queryParams = `?missions[]=${missions.join(
      "&missions[]="
    )}&startDate=${moment(startDate).format("YYYY-MM-DD")}&endDate=${moment(
      endDate
    ).format("YYYY-MM-DD")}`;
    loadData(queryParams, getPilotageClients);
  };

  const a11yProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  };

  const handleSourcing = async (startDate, endDate) => {
    setLoading(true);
    const queryParams = new URLSearchParams();
    queryParams.append("startDate", moment(startDate).format("YYYY-MM-DD"));
    queryParams.append("endDate", moment(endDate).format("YYYY-MM-DD"));
    const search = `?${queryParams.toString()}`;
    try {
      const { data } = await getAllImportationSource(search);
      setSourcesIds(data);
    } catch (error) {
      snackbarShowMessage(
        "Erreur de chargement de sources d'importation!",
        "error",
        4000
      );
    } finally {
      setLoading(false);
    }
  };
  const kpiDatas = [
    {
      title: "PRODUCTION",
      component: <BarChartt data={chartsData.prod} onBarClick={handleProductionBarClick} />,
      cols: 6,
    },
    {
      title: "KPI",
      component: <KPIChart data={chartsData.kpi} />,
      cols: 6,
    },
    {
      title: "EVOLUTION MENSUELLE SUR 12 MOIS",
      component: <MonthlyEvolutionCharts
          data={evolutionData}
          index={indexTab}
          onBarClick={handleEvolutionBarClick}
      />,
      cols: 12,
    },
    {
      title:
        indexTab === 1 ? "TABLEAU COMPARATIF ENTRE CLIENTS SUR LA PLAGE DE DATES CHOISIE" : "TABLEAU COMPARATIF ENTRE CONSULTANTS SUR LA PLAGE DE DATES CHOISIE",
      component: (
        <ComparativeTable
          {...(indexTab === 1 ? { showTsp: true } : { showTsp: false })}
          isLoading={loading}
          data={compareData}
          index={indexTab}
        />
      ),
      cols: 12,
    },
  ];
  const sourcingProps = {
    sourcesIds,
    loading,
  };

  const filterProps = {
    selectedConsultants: filters.selectedConsultants,
    consultants: managers,
    indexTab,
    missionData,
    snackbarShowMessage
  };

  const GenerateChartGrid = (data) => (
    <Grid container spacing={2}>
      {data?.map((item, index) => (
        <Grid
          key={v4()}
          item
          xs={12}
          sm={12}
          md={item.cols}
          lg={item.cols}
          style={index < 2 ? { paddingTop: "0px" } : {}}
        >
          <Card style={{ padding: "30px 20px", marginTop: "10px" }}>
            <strong>{item.title}</strong>
            {item.component}
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  return (
    <>
      <Box
        sx={{
          padding: "0 20px",
      }}
    >
      <Box
        sx={{ padding: 5, display: "flex", gap: "10px", marginBottom: "20px" }}
      >
        <Typography
          className="text-capitalize"
          style={{
            color: "rgb(17, 122, 167)",
            fontSize: "35px",
          }}
        >
          PILOTAGE
        </Typography>
        <Tabs
          value={indexTab}
          onChange={(event, newValue) => setIndexTab(newValue)}
          indicatorColor={loading ? "none" : "secondary"}
          aria-label="full width tabs example"
        >
          {[
            {
              ...(currentUserRole.includes(ROLE.ROLE_TALENT_MANAGER) ? {} :
                { title: "PROD. et KPI Consultants", icon: <ManageAccounts /> }
              )
            },
            {
              ...(currentUserRole.includes(ROLE.ROLE_TALENT_MANAGER) ? {} :
                { title: "PROD. et KPI Clients", icon: <Diversity1 /> }
              )
            },
            {
              ...(currentUserRole.includes(ROLE.ROLE_TALENT_MANAGER) ? {} :
                { title: "Sourcing", icon: "" }
              )
            },
          ].map((tab, index) => (
            <Tab
              key={v4()}
              label={
                <Box sx={{ display: "flex", gap: 5, alignItems: "center" }}>
                  {tab.icon}
                  {!isSmMode && <span>{tab.title}</span>}
                </Box>
              }
              {...a11yProps(index)}
              disabled={loading}
            />
          ))}
        </Tabs>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: "10px",
          position: "relative",
        }}
      >
        {loading && (
          <Box
            sx={{
              display: "flex",
              position: "absolute",
              zIndex: 120,
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: "rgba(255, 255, 255, 0.6)",
            }}
          >
            <Loader />
          </Box>
        )}
        <Grid container spacing={0}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              overflowY: "auto",
              height: "calc(100vh - 140px)",
              maxHeight: "88%"
            }}
            order={2}
          >
            <TabPanel value={indexTab} index={0} dir={theme.direction}>
              {/* Prod. et KPI Consultants */}
              {GenerateChartGrid(kpiDatas)}
            </TabPanel>
            <TabPanel value={indexTab} index={1} dir={theme.direction}>
              {/* Prod. et KPI Clients */}
              {GenerateChartGrid(kpiDatas)}
            </TabPanel>
            <TabPanel value={indexTab} index={2} dir={theme.direction}>
              {/* Sourcing Content */}
              <Sourcing {...sourcingProps}></Sourcing>
            </TabPanel>
          </Grid>
        </Grid>
        <FilterPilote {...filterProps} />
      </Box>
    </Box>

    <ProductionDetailModal
      open={detailModal.open}
      onClose={() => setDetailModal((prev) => ({ ...prev, open: false }))}
      metricType={detailModal.metricType}
      data={detailModal.data}
      loading={detailModal.loading}
      error={detailModal.error}
      metricCounts={metricCounts}
      onMetricChange={(mt) => handleProductionBarClick(METRIC_TYPES.indexOf(mt))}
    />
    </>
  );
};
export default withSnackbar(Pilot);
